import PATHS from '@/router/paths'

export const PERMISSIONS_UNAVAILABLE_ROUTE_NAME = 'permissions-unavailable'

/**
 * Para onde voltar depois de um retry bem-sucedido. O `redirect` vem da query
 * (editável por qualquer um), então só vale caminho interno do SPA: começa com
 * uma única `/`, sem `\` (o browser normaliza `/\` para `//`, que é outro host)
 * e nunca a própria tela de erro.
 */
export function resolveRetryTarget(redirect: unknown): string {
  if (typeof redirect !== 'string') return PATHS.DASHBOARD
  if (!redirect.startsWith('/') || redirect.startsWith('//') || redirect.includes('\\')) {
    return PATHS.DASHBOARD
  }
  if (redirect.split(/[?#]/)[0] === PATHS.PERMISSIONS_UNAVAILABLE) return PATHS.DASHBOARD
  return redirect
}
